// @ts-nocheck
export interface AgentDef {
  id: string;
  label: string;
  purpose: string;
  domains: string[];
}

export const AGENTS: AgentDef[] = [
  {
    id: "supervisor",
    label: "Supervisor Oli",
    purpose: "Routes requests, checks intent, confidence, fallback, and explainability.",
    domains: ["*"],
  },
  {
    id: "task",
    label: "Task Oli",
    purpose: "Creates, assigns, prioritizes, and follows up on tasks and taskflows.",
    domains: ["tasks", "actions", "taskflows"],
  },
  {
    id: "case",
    label: "Case Oli",
    purpose: "Creates, updates, summarizes, and escalates cases and case templates.",
    domains: ["cases"],
  },
  {
    id: "goal",
    label: "Goal Oli",
    purpose: "Handles client goals, planning assumptions, milestones, and next steps.",
    domains: ["goals"],
  },
  {
    id: "review",
    label: "Review Oli",
    purpose: "Supports annual reviews, meeting prep, and review follow-ups.",
    domains: ["reviews"],
  },
  {
    id: "lead",
    label: "Lead Oli",
    purpose: "Qualifies leads, drafts follow-ups, and routes sales opportunities.",
    domains: ["leads", "clients"],
  },
  {
    id: "compliance",
    label: "Compliance Oli",
    purpose: "Detects risk, privacy, complaint, and policy-sensitive issues.",
    domains: ["compliance"],
  },
  {
    id: "workflow",
    label: "Workflow Oli",
    purpose: "Explains and designs workflow automations and reusable playbooks.",
    domains: ["workflows", "automations", "taskflows"],
  },
  {
    id: "communication",
    label: "Communications Oli",
    purpose: "Creates campaigns, forms, email and SMS communications.",
    domains: ["campaigns", "communications", "forms"],
  },
  {
    id: "planning",
    label: "Planning Oli",
    purpose: "Retirement planning, cashflow projections, tax and estate strategies.",
    domains: ["planning"],
  },
  {
    id: "dataQuery",
    label: "Analytics Oli",
    purpose: "Data queries, segment analysis, insights, and reporting.",
    domains: ["analytics", "reports", "segments"],
  },
];

export const DEFAULT_ENABLED_AGENTS = AGENTS.map((a) => a.id);

export function getAgent(id: string): AgentDef | undefined {
  return AGENTS.find((a) => a.id === id);
}

export function isAgentEnabled(agentId: string, enabledIds: string[]): boolean {
  return enabledIds.includes(agentId);
}
